"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

/**
 * Utilities for working with strings.
 * @module StringUtils
 */
var StringUtils = {
  /**
   * Removes spaces from the provided string.
   * @static
   * @function removeSpaces
   * @param {String} str - The string to remove spaces from.
   * @example
   * StringUtils.removeSpaces('Foo Bar'); // 'FooBar'
   * @returns {String} - The string with no spaces.
   */
  removeSpaces: function removeSpaces(str) {
    if (!(0, _isString.default)(str)) {
      throw new Error('You can only remove spaces from a string.');
    }

    return str.replace(/\s+/g, '');
  },

  /**
   * Pads a number with a leading zero if necessary and returns it as a string representation.
   * @static
   * @function padWith
   * @param {Number} num - The number to pad.
   * @param {String} [pad='0'] - The string to pad the number with.
   * @example
   * StringUtils.padWith(1);
   * @returns {String} - The padded number.
   */
  padWith: function padWith(num) {
    var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

    if (!(0, _isNumber.default)(num)) {
      throw new Error('You can only pad numbers.');
    }

    return num < 10 ? "".concat(pad).concat(num) : "".concat(num);
  }
};
var _default = StringUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StringUtils, "StringUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/string/string.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/string/string.js");
  leaveModule(module);
})();

;